module.exports = __webpack_public_path__ + "img/event-done.54e3ef2e.svg";